import { createFileRoute } from "@tanstack/react-router";
import { PlatformPage } from "@/components/PlatformPage";
import { platnosci } from "@/lib/integrations-data";
import { buildSeoMeta } from "@/lib/seo";

const PATH = "/integracje/platnosci";

export const Route = createFileRoute("/integracje/platnosci")({
  head: () =>
    buildSeoMeta({
      title: "Integracja płatności: PayU, Przelewy24, Tpay, Stripe, BLIK | SyncTech",
      description:
        "Wdrożenia bramek płatniczych: PayU, Przelewy24, Tpay, Stripe, PayPal, BLIK, Apple Pay, Google Pay, PayPo, Klarna. Optymalizacja checkoutu pod konwersję. Bezpłatna wycena.",
      path: PATH,
    }),
  component: () => (
    <PlatformPage data={platnosci} path={PATH} breadcrumbCategory="Integracje" />
  ),
});
